(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.shell:mxShellInfoPanel
	 * @module mx.shell
	 *
	 * @description Component to show some info-widgets from infoPanelService (widgets can be added by external services)
	 */
	angular.module('mx.shell').component('mxShellInfoPanel', {
		controller: MxShellInfoPanelCtrl,
		controllerAs: 'vm',
		template: '<div ng-repeat="widget in vm.infoPanelService.widgets" mx-view="widget"></div>',
	});

	MxShellInfoPanelCtrl.$inject = ['mx.shell.InfoPanelService'];

	function MxShellInfoPanelCtrl(infoPanelService) {
		var vm = this;
		vm.infoPanelService = infoPanelService;

		vm.$onInit = function () {};
	}
})();
